import { Badge } from './BadgeNotification.styles';
import { BadgeNotificationProps } from './BadgeNotification.d';

const BadgeNotification = ({ showBadge, children }: BadgeNotificationProps) => {
  return (
    <Badge.Wrapper>
      {showBadge && <Badge.Circle />}
      {children}
    </Badge.Wrapper>
  );
};
export default BadgeNotification;
